import React, { useRef } from "react";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { ClearSvg } from "../Assets";

const AppInput = ({
  control,
  name,
  placeholder,
  label,
  className,
  type = "text",
  maximum = 10,
  isKoreaPhoneNumber = false,
  clearable = false,
  disabled = false,
  readOnly = false,
  backgroundWhite = false,
  inputStyle = {},
  maxLength = 524288 
}) => {
  const inputRef = useRef();
  const [isFocused, setIsFocused] = useState(false);

  const handleNumberChange = (event) => {
    const input = event.target.value;
    let dashAfterFirstNumber = 3;
    let dashAfterSecondNumber = 5;

    if(isKoreaPhoneNumber) {
      dashAfterSecondNumber = 7
    }

    const numericInput = input.replace(/\D/g, "");
    let formattedPhoneNumber = numericInput;
    if (
      numericInput.length > dashAfterFirstNumber &&
      numericInput.length <= dashAfterSecondNumber
    ) {
      formattedPhoneNumber = `${numericInput.slice(
        0,
        dashAfterFirstNumber
      )}-${numericInput.slice(dashAfterFirstNumber)}`;
    } else if (
      numericInput.length >= dashAfterSecondNumber &&
      numericInput.length < maximum + 1
    ) {
      formattedPhoneNumber = `${numericInput.slice(
        0,
        dashAfterFirstNumber
      )}-${numericInput.slice(
        dashAfterFirstNumber,
        dashAfterSecondNumber
      )}-${numericInput.slice(dashAfterSecondNumber)}`;
    }

    return formattedPhoneNumber;
  };

  return (
    <div className={"app-input-wrapper " + className}>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field, formState, fieldState }) => {
          const isError =  formState.errors[name];
          const hasValue = field.value;
          return (
            <div>
              <input
                {...field}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                inputMode={type === "number" ? "numeric" : "text"}
                onChange={(e) => {
                  if (type === "number") {
                    const formattedPhoneNumber = handleNumberChange(e);
                    field.onChange(formattedPhoneNumber);
                  } else {
                    field.onChange(e.target.value);
                  }
                }}
                type="text"
                disabled={disabled}
                readOnly={readOnly}
                style={inputStyle ?? {}}
                maxLength = {maxLength}
                className={
                  isError
                    ? "app-input error"
                    : hasValue
                    ? isFocused
                      ? `app-input focus`
                      : `app-input hasValue ${backgroundWhite && "background-white"}`
                    : `app-input`
                }
                placeholder={placeholder}
                ref={(e) => {
                  field.ref(e);
                  inputRef.current = e; 
                }}
              />

              {hasValue && clearable && (
                <img
                  className="clear-button"
                  src={ClearSvg}
                  alt="Clear"
                  onClick={() => {
                    field.onChange("");
                    inputRef.current.focus();
                  }}
                />
              )}

              <div className="app-input-label">{label}</div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default AppInput;
